import React, { useRef, useState } from "react"
import { Box, Container, Flex, Heading, Grid } from "theme-ui"
import { BsChevronRight } from "react-icons/bs"
import RichContentStructuredText from "../richContentStructuredText"
import { OutboundLink } from "../link"
import {
  Accordion as AccordionWrapper,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion"

const WebinarCollection = ({ block }) => {
  const { title, webinars } = block

  return (
    <Container
      sx={{
        zIndex: 1,
        position: "relative",
      }}
    >
      <Grid
        columns={[1, 1, "4fr 1fr", "4fr 1fr"]}
        gap={[0, 0, 32]}
        sx={{ pt: [0, 0, 0], position: "relative" }}
      >
        <Flex
          sx={{
            flexDirection: "column",
            pt: [5, 7],
          }}
        >
          <Box
            sx={{
              maxWidth: "665px",
            }}
          >
            {title && (
              <Heading
                color="dark"
                as="h2"
                variant="h3"
                sx={{
                  mt: [0, 0],
                  fontWeight: "300",
                  pb: [4],
                }}
              >
                {title}
              </Heading>
            )}
          </Box>
        </Flex>
        {<Box></Box>}
      </Grid>
      <AccordionWrapper allowMultipleExpanded allowZeroExpanded>
        {webinars.map(item => (
          <Box sx={{ mb: [5, 6] }}>
            <AccordionItem key={item.id} uuid={item.id}>
              <AccordionItemHeading>
                <AccordionItemButton>
                  <Flex
                    sx={{
                      pb: [4, 6],
                      borderBottom: "1px solid",
                      borderColor: "dark",
                      alignItems: "center",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      "&:hover": {
                        ".icon": {
                          backgroundColor: "primary",
                          svg: {
                            fill: "light",
                          },
                        },
                      },
                    }}
                  >
                    <Heading
                      as="h2"
                      variant="h3"
                      sx={{
                        my: [0, 0],
                        color: "dark",
                        fontWeight: "300",
                      }}
                    >
                      {item.title}
                    </Heading>
                    <Box
                      as="span"
                      className="icon"
                      sx={{
                        border: "1px solid",
                        borderColor: "dark",
                        minWidth: "40px",
                        minHeight: "40px",
                        borderRadius: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        svg: {
                          // transform: show ? "rotate(90deg)" : "rotate(0deg)",
                          transition: "transform .3s",
                        },
                      }}
                    >
                      <BsChevronRight size={24} />
                    </Box>
                  </Flex>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <Box
                  sx={{
                    pt: [4, 6],
                    overflow: "hidden",
                    li: {
                      borderBottom: "none",
                      mb: [0],
                      alignItems: "flex-start",
                      "&:before": {
                        height: "auto",
                        minHeight: "auto",
                        lineHeight: "1.4",
                      },
                    },
                  }}
                >
                  <RichContentStructuredText text={item.body} />
                </Box>
              </AccordionItemPanel>
            </AccordionItem>
          </Box>
        ))}
      </AccordionWrapper>
    </Container>
  )
}

export default WebinarCollection
